module.exports = __webpack_public_path__ + "static/media/grad-5.caa335ee.svg";